<template>
  <div class="slider">
    <div class="runway">
      <div
        class="handler"
        v-dragged="onDragged"
        :style="{transform:`translatex(${handlerPosX}px)`}"
      >{{currentValue}}</div>
      <div class="progress" :style="{width: `${handlerPosX}px`}"></div>
    </div>
  </div>
</template>

<script>
function mid (val, min, max) {
  return Math.min( Math.max(min, val), max );
}
export default {
  props: {
    partNum: {
      type: Number,
      default: 100
    },
    min: {
      type: Number,
      default: 0
    },
    max: {
      type: Number,
      default: 100
    },
    suffix: {
      type: String,
      default: ''
    },
    numFixed: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      handlerWidth: 40,
      runwayLength: 455,
      isDragging: false,
      handlerPosX: 0,
      startX: 0,
      progress: 0,
    }
  },
  computed: {
    slidingLength () {
      return this.runwayLength - this.handlerWidth;
    },
    partLen () {
      return this.slidingLength / this.partNum;
    },
    currentValue () {
      let num = (this.max - this.min) / this.partNum * this.progress + this.min;
      let fixed = num.toFixed(this.numFixed);
      if (+fixed === 0) {
        fixed = 0
      }
      return fixed + this.suffix;
    }
  },
  methods: {
    init () {

    },
    onDragged({ el, deltaX, deltaY, offsetX, offsetY, clientX, clientY, first, last }) {

      if (first) {
        this.isDragging = true;
        this.startX = this.handlerPosX;
        return
      }
      if (last) {
        this.isDragging = false;
        this.currentValue
        this.$emit('slideEnd', parseFloat(this.currentValue, 10));
        return
      }
      // var l = +window.getComputedStyle(el)['left'].slice(0, -2) || 0
      // var t = +window.getComputedStyle(el)['top'].slice(0, -2) || 0
      // el.style.left = l + deltaX + 'px'
      // el.style.top = t + deltaY + 'px'
      let partLen = this.partLen;
      let partNum = this.partNum;
      let currentX = mid(this.startX + offsetX, 0, this.slidingLength);
      let remain = currentX % partLen;
      let count = currentX / partLen | 0;
      if (remain > partLen / 2) {
        this.progress = count + 1
      } else {
        this.progress = count
      }
      if (this.progress > this.partNum) {
        this.progress = this.partNum;
      }
      this.handlerPosX = this.progress * partLen;

    },
    setProgressTo (partCount) {
      this.progress = mid(partCount, 0, this.partNum);
      this.handlerPosX = this.progress * this.partLen;
    },
    setValue (input) {
      let partCount = Math.round( input / (this.max - this.min) * this.partNum );
      this.setProgressTo(partCount)
    }
  }
}
</script>

<style lang="scss" scoped>
.slider {
  width: 455px;
}
.runway {
  position: relative;
  width: 455px;
	height: 6px;
	background-color: #efeff5;
}
.progress {
  height: 6px;
	background-color: #5778fb;
}
.handler {
  position: absolute;
  left: 0;
  top: 50%;
  margin-top: -10px;
  width: 40px;
	height: 20px;
	background-color: #f4f4f8;
	box-shadow: 0px 0px 6px 0px
		rgba(103, 109, 132, 0.27);
  border: solid 1px #d9ddea;
  font-size: 12px;
}
</style>



// WEBPACK FOOTER //
// src/components/emodal/wordCloud/sliderCloud.vue